document.addEventListener('DOMContentLoaded', (event) => {
	const buttons = document.querySelectorAll('.toggleDialog');

	buttons.forEach((button) => {
		button.addEventListener('click', () => {
			const dialog = button.nextElementSibling;
			if (dialog instanceof HTMLDialogElement) {
                dialog.showModal();

				const closeDialog =(event) => {
                    if (event.target === dialog) {
                        dialog.close();
						dialog.removeEventListener('click',closeDialog);
                    }
                };

				dialog.addEventListener('click', closeDialog);
            }
		});
	});
});